// queries/stripe.ts
import {gql} from "@apollo/client";

export const MY_STRIPE_ACCOUNTS = gql`
  query GetMyStripeAccounts {
      stripeAccounts {
        id
        name
        stripeAccountId
        createdAt
        updatedAt
        payoutsEnabled
        chargesEnabled
        bankLast4
        detailsSubmitted
        country
        user{
          email
        }
      }
    }

`;

export const CREATE_STRIPE_ACCOUNT = gql`
  mutation CreateStripeAccount($name: String!, $country: String) {
    createExpressOnboardingLink(name: $name, country: $country) {
      stripeAccount {
        id
        name
        stripeAccountId
        createdAt
        updatedAt
        payoutsEnabled
        chargesEnabled
        bankLast4
        detailsSubmitted
        country
        user{
          email
        }
      }
      url
    }
  }
`;

export const UPDATE_STRIPE_ACCOUNT = gql`
mutation GenerateStripeOnboardingLink($accountId: ID!) {
  generateStripeOnboardingLink(accountId: $accountId) {
    stripeAccount {
        id
        name
        stripeAccountId
        createdAt
        updatedAt
        payoutsEnabled
        chargesEnabled
        bankLast4
        detailsSubmitted
        country
        user{
          email
        }
      }
      url
  }
}
`
